<template>
  <div>
    <section class="newsList ">
      <div v-for="(item,k) in newList" :key="k">
        <div class="news" @click=goView(item.id,1)>
          <div class="news-item" >
            <div class="right-content">
              <div class="subject">{{ item.title }}</div>
              <div class="info" v-if="item.publish_time">
                <span class="createformat">{{ item.publish_time }}</span>
              </div>
            </div>
            <div class="thumb" >
              <van-image :src="item.titleImgUrl?item.titleImgUrl:item.img"></van-image>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  props: ['newList'],
  data() {
    return {
      loading: false
    }
  },
  methods: {
    goView(id,t) {
      if(t==1 || t==3){
        this.$router.push({name: 'detail', params: {id: id}});
      }else if(t==4){
        this.$router.push({name: 'live', params: {id: id}});
      }else if(t==2){
        this.$router.push({name: 'special', params: {id: id}});
      }else{
        this.$router.push({name: 'detail', params: {id: id}});
      }
    }
  }
}
</script>

<style scoped lang="less">
.newsList {
  padding: 0 10px;

  .labletitle {
    // font-family: caoshu1;
    font-size: 18px;
    color: #323953;

  }
}

</style>